const didFinishLaunchingWithOptions = `- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {

  [self requestData];
  return YES;
}`;

export const objectivecEndpoints = {
    anonymousid:
`NSString *apiKey = @"LIVDSRZULELA";


/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}`,

    trendinggifs:
`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
 Execute web requests to retrieve trending GIFs.
 */
-(void)requestData
{
  // Define the results upper limit
  int limit = 10;

  // Get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
  NSString *trendingUrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/trending?key=%@&limit=%d", apiKey, limit];
  NSURL *trendingUrl = [NSURL URLWithString:trendingUrlString];
  NSURLRequest *trendingRequest = [NSURLRequest requestWithURL:trendingUrl];
  [self makeWebRequest:trendingRequest withCallback:tenorTrendingResultsHandler];


  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NSError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for trending top 10 GIFs.
 */
void (^tenorTrendingResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *topTenGifs = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Trending Results: %@", topTenGifs);
};`,

    categories:
`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
 Execute web requests to retrieve  GIF categories.
 */
-(void)requestData
{

  // Get the current list of categories - using the default locale of en_US
  NSString *categoryUrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/categories?key=%@", apiKey];
  NSURL *categoryUrl = [NSURL URLWithString:categoryUrlString];
  NSURLRequest *categoryRequest = [NSURLRequest requestWithURL:categoryUrl];
  [self makeWebRequest:categoryRequest withCallback:tenorCategoryResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NSError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}


/**
 Web response handler for GIF categories.
 */
void (^tenorCategoryResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *categories = response[@"tags"];

  // Load the categories into your view
  NSLog(@"Category Results: %@", categories);
};`,

    search:
`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
 Execute web request to retrieve the top GIFs returned(in batches of 8) for the given search term.
 */
-(void)requestData
{
  // Define the results upper limit
  int limit = 8;

  // the test search term
  NSString *searchQuery = @"excited";

  // Get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/search?key=%@&q=%@&limit=%d", apiKey, searchQuery, limit];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorSearchResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for searches.
 */
void (^tenorSearchResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *topGifs = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Search Results: %@", topGifs);
};`,

    registershare:
`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
 Function for handling a user's selection of a GIF to share.
 In a production application, the GIF id should be the "id" field of the GIF response object that the user selected
 to share. The search term should be the user's last search.
 */
-(void)requestData
{
  // Define the results upper limit
  int limit = 8;

  // the test search term
  NSString *searchQuery = @"excited";
  int gifId = 8776030;

  //  using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/registershare?id=%d&key=%@&q=%@&limit=%d", gifId, apiKey, searchQuery, limit];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorSearchResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for registered shares
 */
void (^tenorShareResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *result = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Share Result: %@", result);
};`,

    autocomplete:
`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
   Execute web requests to get autocomplete suggestions.
   */
-(void)requestData
{
  // Define the results upper limit
  int limit = 8;

  // the test search term
  NSString *partialSearch = @"exc";

  // Get the auto complete predictions for the given partial search - using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/autocomplete?key=%@&q=%@&limit=%d", apiKey, partialSearch, limit];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorAutoCompleteResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for auto complete predictions
 */
void (^tenorAutoCompleteResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *results = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Auto Complete Result: %@", results);
};`,

    suggestions:
`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
   Execute web requests to get search suggestions.
   */
-(void)requestData
{
  // Define the results upper limit
  int limit = 8;

  // the test search term
  NSString *lastSearch = @"excited";

  // Get the search suggestions for the given last search - using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/search_suggestions?key=%@&q=%@&limit=%d", apiKey, lastSearch, limit];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorSearchSuggestionResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for search suggestions
 */
void (^tenorSearchSuggestionResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *results = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Search Suggestion Result: %@", results);
};`,

    gifs:
`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
 Execute web request to retrieve the requested gif.
 */
-(void)requestData
{
  // Define the results upper limit
  int gifid = 8776030;

  // Get the GIF - using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/gifs?key=%@&ids=%@", apiKey, gifid];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorgifResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for searches.
 */
void (^tenorgifResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *gif = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"GIF Results: %@", gif);
};`,

    random:
`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
 Execute web request to retrieve random GIFs returned(in batches of 8) for the given search term.
 */
-(void)requestData
{
  // Define the results upper limit
  int limit = 8;

  // the test search term
  NSString *searchQuery = @"excited";

  // Get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/random?key=%@&q=%@&limit=%d", apiKey, searchQuery, limit];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorRandomSearchResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for random calls.
 */
void (^tenorRandomSearchResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *gifs = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Random Search Results: %@", gifs);
};`,

    trendingterms:
`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
 Execute web requests to retrieve trending terms.
 */
-(void)requestData
{

  // Get the current list of categories - using the default locale of en_US
  NSString *categoryUrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/trending_terms?key=%@", apiKey];
  NSURL *categoryUrl = [NSURL URLWithString:categoryUrlString];
  NSURLRequest *categoryRequest = [NSURLRequest requestWithURL:categoryUrl];
  [self makeWebRequest:categoryRequest withCallback:tenorTermsResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NSError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}


/**
 Web response handler for GIF categories.
 */
void (^tenorTermsResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *terms = response[@"results"];

  // Load the categories into your view
  NSLog(@"Trending Terms: %@", terms);
};`,

    search_stickers:
`NSString *apiKey = @"LIVDSRZULELA";

- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {

  [self requestData];
  return YES;
}

/**
 Execute web request to retrieve the top GIFs returned(in batches of 8) for the given search term.
 */
-(void)requestData
{
  // Define the results upper limit
  int limit = 10;

  // the test search term
  NSString *searchQuery = @"excited";

  // Get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/search?searchfilter=sticker&key=%@&q=%@&limit=%d", apiKey, searchQuery, limit];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorSearchResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for searches.
 */
void (^tenorSearchResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *topStickers = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Search Results: %@", topStickers);
};`,

    trending_stickers:
`NSString *apiKey = @"LIVDSRZULELA";

- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {

  [self requestData];
  return YES;
}

/**
 Execute web requests to retrieve trending stickers.
 */
-(void)requestData
{
  // Define the results upper limit
  int limit = 10;

  // Get the top 10 trending stickers (updated throughout the day) - using the default locale of en_US
  NSString *trendingUrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/trending?searchfilter=sticker&key=%@&limit=%d", apiKey, limit];
  NSURL *trendingUrl = [NSURL URLWithString:trendingUrlString];
  NSURLRequest *trendingRequest = [NSURLRequest requestWithURL:trendingUrl];
  [self makeWebRequest:trendingRequest withCallback:tenorTrendingResultsHandler];


  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NSError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for trending top 10 stickers.
 */
void (^tenorTrendingResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *topTenStickers = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Trending Results: %@", topTenStickers);
};`,
};

export const objectivecQuickStart = {
    launch:

`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
 Execute web requests to retrieve trending GIFs and GIF categories.
 */
-(void)requestData
{
  // Define the results upper limit
  int limit = 10;

  // Get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
  NSString *trendingUrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/trending?key=%@&limit=%d", apiKey, limit];
  NSURL *trendingUrl = [NSURL URLWithString:trendingUrlString];
  NSURLRequest *trendingRequest = [NSURLRequest requestWithURL:trendingUrl];
  [self makeWebRequest:trendingRequest withCallback:tenorTrendingResultsHandler];

  // Get the current list of categories - using the default locale of en_US
  NSString *categoryUrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/categories?key=%@", apiKey];
  NSURL *categoryUrl = [NSURL URLWithString:categoryUrlString];
  NSURLRequest *categoryRequest = [NSURLRequest requestWithURL:categoryUrl];
  [self makeWebRequest:categoryRequest withCallback:tenorCategoryResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NSError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for trending top 10 GIFs.
 */
void (^tenorTrendingResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *topTenGifs = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Trending Results: %@", topTenGifs);
};

/**
 Web response handler for GIF categories.
 */
void (^tenorCategoryResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *categories = response[@"tags"];

  // Load the categories into your view
  NSLog(@"Category Results: %@", categories);
};`,
    search:

`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
 Execute web request to retrieve the top GIFs returned(in batches of 8) for the given search term.
 */
-(void)requestData
{
  // Define the results upper limit
  int limit = 8;

  // the test search term
  NSString *searchQuery = @"excited";

  // Get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/search?key=%@&q=%@&limit=%d", apiKey, searchQuery, limit];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorSearchResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for searches.
 */
void (^tenorSearchResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *topGifs = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Search Results: %@", topGifs);
};`,
    registershare:

`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
 Function for handling a user's selection of a GIF to share.
 In a production application, the GIF id should be the "id" field of the GIF response object that the user selected
 to share. The search term should be the user's last search.
 */
-(void)requestData
{
  // Define the results upper limit
  int limit = 8;

  // the test search term
  NSString *searchQuery = @"excited";
  int gifId = 8776030;

  // Get the top 10 trending GIFs (updated through out the day) - using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/registershare?id=%d&key=%@&q=%@&limit=%d", gifId, apiKey, searchQuery, limit];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorSearchResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for registered shares
 */
void (^tenorShareResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *result = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Share Result: %@", result);
};`,
    autocomplete:

`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
   Execute web requests to get autocomplete suggestions.
   */
-(void)requestData
{
  // Define the results upper limit
  int limit = 8;

  // the test search term
  NSString *partialSearch = @"exc";

  // Get the auto complete predictions for the given partial search - using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/autocomplete?key=%@&q=%@&limit=%d", apiKey, partialSearch, limit];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorAutoCompleteResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for auto complete predictions
 */
void (^tenorAutoCompleteResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *results = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Auto Complete Result: %@", results);
};`,
    suggestions:

`NSString *apiKey = @"LIVDSRZULELA";

${didFinishLaunchingWithOptions}

/**
   Execute web requests to get search suggestions.
   */
-(void)requestData
{
  // Define the results upper limit
  int limit = 5;

  // the test search term
  NSString *lastSearch = @"smile";

  // Get the search suggestions for the given last search - using the default locale of en_US
  NSString *UrlString = [NSString stringWithFormat:@"https://g.tenor.com/v1/search_suggestions?key=%@&q=%@&limit=%d", apiKey, lastSearch, limit];
  NSURL *searchUrl = [NSURL URLWithString:UrlString];
  NSURLRequest *searchRequest = [NSURLRequest requestWithURL:searchUrl];
  [self makeWebRequest:searchRequest withCallback:tenorSearchSuggestionResultsHandler];

  // Data will be loaded by each request's callback
}

/**
 Async URL requesting function.
 */
-(void)makeWebRequest:(NSURLRequest *)urlRequest withCallback:(void (^)(NSDictionary *))callback
{
  // Make the async request and pass the resulting json object to the callback
  NSURLSessionTask *task = [[NSURLSession sharedSession] dataTaskWithRequest:urlRequest completionHandler:^(NSData * _Nullable data, NSURLResponse * _Nullable response, NSError * _Nullable error) {
    NStopGifsError *jsonError = nil;
    NSDictionary *jsonResult = [NSJSONSerialization JSONObjectWithData:data options:NSJSONReadingMutableLeaves error:&jsonError];

    if(jsonError != nil) {
      NSLog(@"%@", jsonError.localizedDescription);
      return;
    }

    // Push the results to our callback
    callback(jsonResult);
  }];

  [task resume];
}

/**
 Web response handler for search suggestions
 */
void (^tenorSearchSuggestionResultsHandler)(NSDictionary *) = ^void(NSDictionary *response)
{
  // Parse the json response
  NSDictionary *results = response[@"results"];

  // Load the GIFs into your view
  NSLog(@"Search Suggestion Result: %@", results);
};`,
};
